import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

import * as mappingEntry from './mapping-entry'

export const DOC = gql`
  ${mappingEntry.DOC}
  fragment FragmentRateMapping on RateMapping {
    adjustmentLabel
    entries {
      ...FragmentRateMappingEntry
    }
  }
`
export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentRateMappingFragment,
  ents.extra.rate.gl.Mapping
>({
  adjustmentLabel: transformers.PASS_THROUGH,
  entries: graphql.transformers.OUT.default(
    graphql.transformers.OUT.list(mappingEntry.TRANSFORMER, {
      onNullish: 'remove',
    }),
    [],
  ),
})
